import Moment from 'moment';

const dateFormat = 'DD MM YYYY';

export const Validation = {
    Ragularexpression: (value, validations, compareWith, length) => {
        // if(error){

        // }
        if (value) {
            let error = validations.map((validation) => {
                let reg;
                if (validation.validator === "Date") {
                    let startDate = Moment(compareWith)?.format(dateFormat);
                    let endDate = Moment(value)?.format(dateFormat);
                    console.log(compareWith>value);
                    console.log(value);
                    if (compareWith > value) {
                        return validation.error;
                    }
                }
                else {
                    switch (validation.validator) {
                        case 'stringWithSpace':
                            if (length) {
                                reg = RegExp(/^[A-Za-z_]{length}$/);
                            }
                            else {
                                reg = RegExp(/^[a-zA-Z\s]*$/);
                            }
                            break;

                        case 'ContactNumber':
                            reg = RegExp(/^[0-9]{10}$/);
                            break;

                        case 'schoolemail':
                            reg = "schoolemail";
                            break;

                        case 'email':
                            if (length) {
                                reg = RegExp(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+{length}$/);
                            }

                            else {
                                reg = RegExp(/[a-z0-9]+@[a-z]+\.[a-z]/);
                            }
                            break;

                        case 'number':
                            if (length) {
                                reg = RegExp(/[0-9]{length}$/);
                            }

                            else {
                                reg = RegExp(/^[0-9]/);
                            }
                            break;

                        case 'onlyString':
                            if (length) {
                                reg = RegExp(/^[A-Za-z]{length}+$/);
                            }

                            else {
                                reg = RegExp(/^[A-Za-z]+$/);
                            }
                            break;
                    }

                    if (reg === "schoolemail") {
                        if (value.substr(-16) !== '@chitkara.edu.in' 
                        || value === '@chitkara.edu.in') {
                            return validation.error;
                        }
                    }

                    else if (!reg.test(value)) {
                        return validation.error;
                    }
                }
            });
            if (error) {
                return error;
            }
        }
        return;
    }
};